// extracted by mini-css-extract-plugin
export default {"mainButton":"MainButton_mainButton__Yachk"};